<div *ngIf="isNotFromPSE" >
  <div class="cre-navbar-logo-container">
    <div class="cre-layout-content">
      <a
        href="http://www.crengland.com"
        title="C.R England Home"
      >
        <img
          class="cre-navbar-logo"
          src="/themes/workbench3/images/logo.png"
          alt="C.R. England"
        />
      </a>
    </div>
  </div>
  <div class="cre-navbar-menu-container">
    <div class="cre-navbar-menu cre-layout-content">
      <button
        class="cre-navbar-button-back cre-navbar-menu-button"
        (click)="goToEtools()"
      >
        Back to Etools
      </button>
      <button
        class="cre-navbar-menu-button"
        *ngIf="canSearch"
        (click)="search()"
      >
        Search
      </button>
      <button
        class="cre-navbar-button-forward cre-navbar-menu-button"
        (click)="logout()"
      >
        Log out
      </button>
    </div>
  </div>
</div>

